import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {SubscriptionSummaryModel} from "../subscriptionSummary.model";

@Injectable({
    providedIn: 'root'
})
export class SubscriptionSummaryConverter extends HttpModelConverter<SubscriptionSummaryModel> {

    constructor() {
        super();
    }

    protected createInstance(): SubscriptionSummaryModel {
        return new SubscriptionSummaryModel();
    }

    protected enrichObject(result: SubscriptionSummaryModel, src: SubscriptionSummaryModel) {
    }
}
